// extracted by mini-css-extract-plugin
module.exports = {"container":"e_u5","title":"e_v5","titleIcon":"e_w5","summary":"e_x5","sourcesTitle":"e_y5","sources":"e_z5","source":"e_A5"};